<div class="sub-header">
  <h1 class="title">{{ title() }}</h1>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
